/**
 * Meta WhatsApp Business Profile API — Waba /api/messaging/business-profile
 *
 * Pass userId when an admin manages another tenant (/users/manage/{id}/business-profile).
 */

import apiClient from 'services/apiClient';

const tenantParams = (userId) =>
  userId ? { params: { user_id: userId } } : {};

export const fetchBusinessProfile = (userId) =>
  apiClient.get('messaging/business-profile', tenantParams(userId)).then((res) => res.data);

export const updateBusinessProfile = (payload, userId) =>
  apiClient
    .put('messaging/business-profile', payload, tenantParams(userId))
    .then((res) => res.data);

export const refreshBusinessProfile = (userId) =>
  apiClient
    .post('messaging/business-profile/refresh', null, tenantParams(userId))
    .then((res) => res.data);

export const updateBusinessProfilePicture = (mediaId, userId) =>
  apiClient
    .post(
      'messaging/business-profile/profile-picture',
      { media_id: String(mediaId) },
      tenantParams(userId),
    )
    .then((res) => res.data);

export const fetchBusinessProfileVerticals = () =>
  apiClient.get('messaging/business-profile/verticals').then((res) => res.data);
